var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { I18nService } from '@app/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { AuthService } from '@app/auth.service';
import { UtilService } from '@app/utility/util.service';
import { ApiService } from '@app/utility/api.service';
import { FormBuilder, Validators } from '@angular/forms';
import { timer } from 'rxjs/observable/timer';
import { TranslateService } from '@ngx-translate/core';
import { NotiService } from '@app/noti.service';
var LoginComponent = /** @class */ (function () {
    function LoginComponent(Auth, route, router, i18nService, util, apiService, fb, notiService, translate) {
        this.Auth = Auth;
        this.route = route;
        this.router = router;
        this.i18nService = i18nService;
        this.util = util;
        this.apiService = apiService;
        this.fb = fb;
        this.notiService = notiService;
        this.translate = translate;
        this.isLoading = false;
        this.submitted = false;
        this.returnUrl = "";
        this.isCompany = false;
        this.isCrisis = true;
        this.showLoginForm = true;
        this.showQRForm = false;
        this.showOtp = false;
        this.telephoneOtp = "";
        this.otp = "";
        this.otpRef = "";
        this.requestOtpLbl = "ขอรหัส OTP";
        this.requestOtpLblTmp = "ขอรหัส OTP";
        this.otpTimer = "";
        this.dpa_portal = {};
        this.disableResentOtp = false;
        this.totolWaitResend = 59;
        this.ElapseTime = 0;
        this.TotalTime = 0;
        this.OTPCountDown = "";
        this.regisMenu = {};
        this.lang = "th";
        this.menuEnabled = false;
        this.form = this.fb.group({
            username: ['', Validators.required],
            password: ['', Validators.required],
            ip: ""
        });
        router.events.subscribe(function (val) {
            // see also
            if (val instanceof NavigationEnd) {
                console.log(val.url);
            }
        });
    }
    Object.defineProperty(LoginComponent.prototype, "formControl", {
        get: function () {
            return this.form.controls;
        },
        enumerable: true,
        configurable: true
    });
    LoginComponent.prototype.handleKeyboardEvent = function (event) {
        if (event.key == "Enter") {
            this.Login();
        }
    };
    LoginComponent.prototype.ngOnDestroy = function () {
        if (this.notiSubscription) {
            this.notiSubscription.unsubscribe();
        }
    };
    LoginComponent.prototype.ngOnInit = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var config, crisisConfig, menuList, thisMenu, regisMenu, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.util.ShowWaiting(true);
                        this.cookieData = JSON.parse(localStorage.getItem("dpa_portal"));
                        if (this.cookieData == null) {
                            this.cookieData = {};
                        }
                        return [4 /*yield*/, this.apiService.get("master", "configuration")];
                    case 1:
                        config = _b.sent();
                        crisisConfig = config.filter(function (c) {
                            return c.dpa_name == "CRISIS FLAG";
                        });
                        if (crisisConfig != null && crisisConfig.length > 0 && crisisConfig[0].dpa_crisisflag != null && crisisConfig[0].dpa_crisisflag == true) {
                            this.cookieData.isCrisis = true;
                            this.isCrisis = true;
                            localStorage.setItem("dpa_portal", JSON.stringify(this.cookieData));
                            $(".btn-social-login").addClass("sr-only");
                        }
                        else {
                            this.cookieData.isCrisis = false;
                            this.isCrisis = false;
                            $(".btn-social-login").removeClass("sr-only");
                            localStorage.setItem("dpa_portal", JSON.stringify(this.cookieData));
                        }
                        return [4 /*yield*/, this.apiService.get("master", "customerPortalMenuSetting")];
                    case 2:
                        menuList = _b.sent();
                        thisMenu = this.util.getMenuObj(menuList, "04", this.isCrisis);
                        regisMenu = this.util.getMenuObj(menuList, "11", this.isCrisis);
                        if (!thisMenu.show && !regisMenu.show) {
                            this.util.ShowWaiting(false);
                            setTimeout(function () {
                                _this.router.navigate(["mainmenu/index"]);
                            }, 500);
                            return [2 /*return*/];
                        }
                        else {
                            this.menuEnabled = true;
                        }
                        // let tmpLang = this.util.GetCurrentLang()
                        // this.lang = tmpLang.substring(0,2)
                        // this.util.SetLanguage(tmpLang)
                        this.notiSubscription = this.notiService.message.subscribe(function (_lang) {
                            _this.lang = _lang;
                            _this.swithLbl();
                        });
                        return [4 /*yield*/, this.util.getIPAddress().subscribe(function (res) {
                                _this.form.controls["ip"].setValue(res.json().ip);
                            })];
                    case 3:
                        _b.sent();
                        this.route.queryParams.subscribe(function (params) {
                            if (params != null && params['error'] == null && params['code'] != null) {
                                _this.getLineProfile(params);
                            }
                            else {
                                _this.util.ShowWaiting(false);
                            }
                        });
                        _a = this;
                        return [4 /*yield*/, this.apiService.get("master", "customerPortalMenuSetting")];
                    case 4:
                        _a.menuList = _b.sent();
                        this.regisMenu = this.getMenuObj("11");
                        this.returnUrl = this.route.snapshot.queryParams['returnUrl'];
                        this.fbLibrary();
                        return [2 /*return*/];
                }
            });
        });
    };
    LoginComponent.prototype.showAgreementDialog = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                //$('#agreementDialog').modal({
                //  backdrop: 'static',
                //  keyboard: false
                //});
                this.router.navigate(["singlegatewaywait3"]);
                return [2 /*return*/];
            });
        });
    };
    LoginComponent.prototype.swithLbl = function () {
        if (this.requestOtpLblTmp == "ขอรหัส OTP") {
            var lblTmp = this.translate.get("RequestOTP");
            this.requestOtpLbl = lblTmp.value;
        }
        else {
            var lblTmp = this.translate.get("ResendOTP");
            this.requestOtpLbl = lblTmp.value;
        }
    };
    LoginComponent.prototype.btnAgreement = function () {
        var _this = this;
        this.showLoginForm = false;
        this.showQRForm = true;
        if (this.showQRForm) {
            setTimeout(function () {
                var thisTs = _this;
                _this.util.WarningDialog("หมดเวลาแสดง QR Code <br> กรุณาเข้าหน้า login ใหม่อีกครั้ง");
                _this.showQRForm = false;
                $("#btnWarningOK").click(function () {
                    thisTs.router.navigate(["/mainmenu/index"]);
                });
                //this.router.navigate(["mainmenu/index"])
            }, 30000);
            return;
        }
    };
    LoginComponent.prototype.Login = function () {
        return __awaiter(this, void 0, void 0, function () {
            var res, contact, _a, _b, _c, thisTs_1, ticket, url, thisTs_2, ex_1;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        _d.trys.push([0, 13, , 14]);
                        this.submitted = true;
                        if (!this.form.valid) return [3 /*break*/, 12];
                        this.util.ShowWaiting(true);
                        localStorage.removeItem("oneOTP");
                        return [4 /*yield*/, this.apiService.postCustomApi("User", "Login", this.form.value)];
                    case 1:
                        res = _d.sent();
                        this.util.ShowWaiting(false);
                        if (!(res != null && res.customerid != null && res.customerid != "")) return [3 /*break*/, 11];
                        this.dpa_portal = {
                            firstname: res.firstname,
                            lastname: res.lastname,
                            email: res.username,
                            contactid: res.customerid,
                            pid: res.pid,
                            readNewsList: res.readNewsList
                        };
                        return [4 /*yield*/, this.apiService.get("crmservice", "contact", "contactid=" + res.customerid)];
                    case 2:
                        contact = _d.sent();
                        contact = contact[0];
                        if (!this.isCrisis) return [3 /*break*/, 9];
                        if (!(contact.dpa_companytypeid != null && contact.dpa_companytypeid.trim().length > 0)) return [3 /*break*/, 4];
                        _a = this;
                        return [4 /*yield*/, this.getContactDROS(contact.dpa_registrationid)];
                    case 3:
                        _a.ContactDros = _d.sent();
                        return [3 /*break*/, 8];
                    case 4:
                        if (!(contact.dpa_passport != null && contact.dpa_passport.trim().length > 0)) return [3 /*break*/, 6];
                        _b = this;
                        return [4 /*yield*/, this.getContactDROS(contact.dpa_passport)];
                    case 5:
                        _b.ContactDros = _d.sent();
                        return [3 /*break*/, 8];
                    case 6:
                        _c = this;
                        return [4 /*yield*/, this.getContactDROS(contact.dpa_idcard)];
                    case 7:
                        _c.ContactDros = _d.sent();
                        _d.label = 8;
                    case 8:
                        if (!this.util.IsNullOrUndefined(this.ContactDros.CRM06)) {
                            if (!this.util.IsNullOrUndefined(this.ContactDros.CRM06.AccountStatus) && this.ContactDros.CRM06.AccountStatus == '2') {
                                thisTs_1 = this;
                                this.util.WarningDialog("กรุณาติดต่อ DPA Call Center 1158");
                                $("#btnWarningOK").click(function () {
                                    thisTs_1.router.navigate(["/mainmenu/index"]);
                                });
                                //thisTs.router.navigate(["mainmenu/index"])
                                return [2 /*return*/];
                            }
                            //if(!this.util.IsNullOrUndefined(this.ContactDros.CRM06.AccountStatus) && this.ContactDros.CRM06.AccountStatus == '3')
                            //{ 
                            //let thisTs = this;
                            //this.util.WarningDialog("กรุณาติดต่อ DPA Call Center 1158");
                            //$("#btnWarningOK").click(function () {
                            //  thisTs.router.navigate(["/mainmenu/index"]);
                            //});
                            ////thisTs.router.navigate(["mainmenu/index"])
                            //return;
                            //}
                        }
                        _d.label = 9;
                    case 9:
                        this.util.ShowWaiting(false);
                        if (contact != null && contact.length > 0) {
                            this.telephoneOtp = contact[0].telephone1;
                        }
                        this.cookieData = this.dpa_portal;
                        localStorage.setItem("dpa_portal", JSON.stringify(this.dpa_portal));
                        return [4 /*yield*/, this.apiService.get("crmservice", "searchApprovalTicket", "contactid=" + this.cookieData.contactid)];
                    case 10:
                        ticket = _d.sent();
                        this.util.ShowWaiting(false);
                        if (ticket != null && ticket.length > 0 && (ticket[0].dpa_approvalstatuscode == "01" || ticket[0].dpa_approvalstatuscode == "02" || ticket[0].dpa_approvalstatuscode == "06")) {
                            url = this.util.baseUrl() + "/mainmenu/statusDocument/" + this.cookieData.contactid;
                            window.open(url, "_blank");
                            this.showLoginForm = false;
                            this.showOtp = true;
                        }
                        else {
                            this.router.navigate(["mainmenu/refundDeposits"]);
                        }
                        return [3 /*break*/, 12];
                    case 11:
                        if (res != null && res.islock != null && res.islock) {
                            thisTs_2 = this;
                            if (res.lockmin != null) {
                                this.util.ErrorDialog("กรุณารอสักครู่ ท่านได้ทำรายการเกินจำนวนครั้งที่กำหนด ท่านจะสามารถดำเนินการใหม่ได้หลังจากครบ " + res.lockmin + " นาที");
                            }
                            else {
                                this.util.ErrorDialog("กรุณารอสักครู่ ท่านได้ทำรายการเกินจำนวนครั้งที่กำหนด");
                            }
                            $("#btnMainError").off("click");
                            $("#btnMainError").click(function () {
                                thisTs_2.router.navigate(["/mainmenu/index"]);
                            });
                        }
                        else {
                            this.util.ErrorDialog("Username หรือ Password ไม่ถูกต้อง ท่านสามารถลองใหม่ได้รวมทั้งหมดไม่เกิน 3 ครั้ง");
                        }
                        _d.label = 12;
                    case 12: return [3 /*break*/, 14];
                    case 13:
                        ex_1 = _d.sent();
                        this.util.ShowWaiting(false);
                        console.log(ex_1);
                        this.util.ErrorDialog('เกิดข้อผิดพลาด กรุณาติดต่อเจ้าหน้าที่');
                        return [3 /*break*/, 14];
                    case 14: return [2 /*return*/];
                }
            });
        });
    };
    LoginComponent.prototype.CheckSession = function () {
        return __awaiter(this, void 0, void 0, function () {
            var str, data, res, check, res2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        str = '';
                        $('#divData').html(str);
                        data = {};
                        data['member_no'] = $('#txtUserName').val();
                        return [4 /*yield*/, this.apiService.postnotauthen('account', 'GetUserSession', data)];
                    case 1:
                        res = _a.sent();
                        this.util.ShowWaiting(false);
                        check = 0;
                        if (res.isSuccess) {
                            if (res.responseData != null) {
                                if (res.responseData.length > 0) {
                                    check++;
                                    this.ip_add = res.responseData[0].ip_address;
                                }
                            }
                        }
                        if (!(check == 0)) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.apiService.postnotauthen('account', 'InsertUserSession', data)];
                    case 2:
                        res2 = _a.sent();
                        this.VisitApp(this.url);
                        return [3 /*break*/, 4];
                    case 3:
                        this.util.ErrorDialog("user นี้ถูกใช้งานอยู่ (ip:" + this.ip_add + ")");
                        _a.label = 4;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    LoginComponent.prototype.VisitApp = function (url) {
        // window.location.href = url; 
        this.router.navigate([url]);
    };
    LoginComponent.prototype.setLanguage = function (language) {
        this.i18nService.language = language;
    };
    Object.defineProperty(LoginComponent.prototype, "currentLanguage", {
        get: function () {
            return this.i18nService.language;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LoginComponent.prototype, "languages", {
        get: function () {
            return this.i18nService.supportedLanguages;
        },
        enumerable: true,
        configurable: true
    });
    LoginComponent.prototype.ForgetPassword = function () {
        $('#txtMemberNo').val($('#txtUserName').val());
        $('#txtOldPassword').val('');
        $('#txtNewPassword').val('');
        $('#txtConfirmNewPassword').val('');
        $('#lblError').html('');
        $('#lblSuccess').html('');
        $('#dlgForgetPassword').modal({ backdrop: 'static', keyboard: false });
    };
    LoginComponent.prototype.SavePassword = function () {
        return __awaiter(this, void 0, void 0, function () {
            var data, res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!($('#txtMemberNo').val() != null && $('#txtMemberNo').val() != '')) return [3 /*break*/, 10];
                        if (!($('#txtOldPassword').val() != null && $('#txtOldPassword').val() != '')) return [3 /*break*/, 8];
                        if (!($('#txtNewPassword').val() != null && $('#txtNewPassword').val() != '')) return [3 /*break*/, 6];
                        if (!($('#txtConfirmNewPassword').val() != null && $('#txtConfirmNewPassword').val() != '')) return [3 /*break*/, 4];
                        if (!($('#txtNewPassword').val() == $('#txtConfirmNewPassword').val())) return [3 /*break*/, 2];
                        this.util.ShowWaiting(true);
                        data = {};
                        data["member_no"] = $('#txtMemberNo').val();
                        data["old_password"] = $('#txtOldPassword').val();
                        data["new_password"] = $('#txtNewPassword').val();
                        return [4 /*yield*/, this.apiService.postnotauthen('member', 'UpdatePassword', data)];
                    case 1:
                        res = _a.sent();
                        this.util.ShowWaiting(false);
                        if (res != null) {
                            if (res.isSuccess) {
                                // $('#dlgForgetPassword').modal('hide');
                                //  this.util.SuccessDialog('บันทึกสำเร็จ');
                                $('#lblError').html('');
                                $('#lblSuccess').html('บันทึกสำเร็จ:' + res.errorMessage);
                            }
                            else {
                                $('#lblError').html(res.errorCode + '-' + res.errorMessage);
                            }
                        }
                        else {
                            $('#lblError').html('System Error');
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        $('#lblError').html('รหัสผ่านใหม่ไม่ตรงกัน');
                        _a.label = 3;
                    case 3: return [3 /*break*/, 5];
                    case 4:
                        $('#lblError').html('กรุณากรอกค่าให้ครบถ้วน');
                        $('#txtConfirmNewPassword').focus();
                        _a.label = 5;
                    case 5: return [3 /*break*/, 7];
                    case 6:
                        $('#lblError').html('กรุณากรอกค่าให้ครบถ้วน');
                        $('#txtNewPassword').focus();
                        _a.label = 7;
                    case 7: return [3 /*break*/, 9];
                    case 8:
                        $('#lblError').html('กรุณากรอกค่าให้ครบถ้วน');
                        $('#txtOldPassword').focus();
                        _a.label = 9;
                    case 9: return [3 /*break*/, 11];
                    case 10:
                        $('#lblError').html('กรุณากรอกค่าให้ครบถ้วน');
                        $('#txtMemberNo').focus();
                        _a.label = 11;
                    case 11: return [2 /*return*/];
                }
            });
        });
    };
    LoginComponent.prototype.clear = function () {
        this.form.controls["username"].setValue("");
        this.form.controls["password"].setValue("");
        this.submitted = false;
    };
    LoginComponent.prototype.forgetPassword = function () {
    };
    LoginComponent.prototype.onTypeChange = function (target) {
        if (target.checked) {
            this.isCompany = target.value == "c";
        }
    };
    LoginComponent.prototype.fbLogin = function () {
        window['FB'].login(function (response) {
            if (response.authResponse) {
                window['FB'].api('/me', {
                    fields: 'last_name, first_name, email'
                }, function (userInfo) {
                    console.log("user information");
                });
            }
            else {
                console.log('User login failed');
            }
        }, { scope: 'email' });
        // // Initialize with your OAuth.io app public key
        // OAuth.initialize('HwAr2OtSxRgEEnO2-JnYjsuA3tc');
        // // Use popup for oauth
        // OAuth.popup('facebook').then((facebook: any) => {
        //   console.log('facebook:', facebook);
        //   // Prompts 'welcome' message with User's email on successful login
        //   // #me() is a convenient method to retrieve user data without requiring you
        //   // to know which OAuth provider url to call
        //   facebook.me().then((data: any) => {
        //     console.log('me data:', data);
        //     alert('Facebook says your email is:' + data.email + ".\nView browser 'Console Log' for more details");
        //   })
        //   // Retrieves user data from OAuth provider by using #get() and
        //   // OAuth provider url
        //   facebook.get('/v2.5/me?fields=name,first_name,last_name,email,gender,location,locale,work,languages,birthday,relationship_status,hometown,picture').then((data: any) => {
        //     console.log('self data:', data);
        //     let userData: any = {
        //       firstname:  data.firstname,
        //       lastname: data.lastname,
        //       emailaddress1: data.email
        //     }
        //     localStorage.setItem("dpa_portal", JSON.stringify(userData))
        //     this.createContact()
        //   })
        // });
    };
    LoginComponent.prototype.signOut = function () {
        var auth2 = gapi.auth2.getAuthInstance();
        auth2.signOut().then(function () {
            console.log('User signed out.');
        });
    };
    LoginComponent.prototype.getLineProfile = function (params) {
        return __awaiter(this, void 0, void 0, function () {
            var reqObj, res, token, userData, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        reqObj = {};
                        reqObj["grant_type"] = "authorization_code";
                        reqObj["code"] = params["code"];
                        reqObj["redirect_uri"] = this.util.baseUrl() + "/mainmenu/login";
                        reqObj["client_id"] = "1654952386";
                        reqObj["client_secret"] = "d129b1c240d16dde27204dadbc5f612c";
                        return [4 /*yield*/, this.apiService.postOther('https://api.line.me/oauth2/v2.1/token', reqObj, "application/x-www-form-urlencoded")];
                    case 1:
                        res = _b.sent();
                        if (!(res != null && res["id_token"] != null)) return [3 /*break*/, 3];
                        token = res["id_token"];
                        userData = this.parseJwt(token);
                        this.cookieData.firstname = userData.name;
                        this.cookieData.lastname = "";
                        this.cookieData.emailaddress1 = userData.email;
                        this.cookieData.imgUrl = userData.picture;
                        _a = this;
                        return [4 /*yield*/, this.apiService.getCustomAPI("User", "GetUser", "username=" + userData.email)];
                    case 2:
                        _a.PortalLogin = _b.sent();
                        if (this.PortalLogin != null && this.PortalLogin.length > 0) {
                            this.cookieData.contactid = this.PortalLogin.customerid;
                        }
                        else {
                            this.cookieData.contactid = null;
                        }
                        localStorage.setItem("dpa_portal", JSON.stringify(this.cookieData));
                        this.router.navigate(["mainmenu"]);
                        _b.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    LoginComponent.prototype.lineLogin = function () {
        var clientId = "1654952386";
        var redirectUri = this.util.baseUrl() + "/mainmenu/login";
        var state = "1234abcd";
        var scope = "profile%20openid%20email";
        var nonce = "089898zyxzyx";
        window.location.href = "https://access.line.me/oauth2/v2.1/authorize?response_type=code&client_id=" + clientId + "&redirect_uri=" + redirectUri + "&state=" + state + "&scope=" + scope + "&nonce=" + nonce;
    };
    LoginComponent.prototype.parseJwt = function (token) {
        var base64Url = token.split('.')[1];
        var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        var jsonPayload = decodeURIComponent(atob(base64).split('').map(function (c) {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        }).join(''));
        return JSON.parse(jsonPayload);
    };
    ;
    LoginComponent.prototype.createContact = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var contactid, req;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        contactid = "";
                        req = {
                            firstname: this.cookieData.firstname,
                            lastname: this.cookieData.lastname,
                            emailaddress1: this.cookieData.email
                        };
                        return [4 /*yield*/, this.apiService.post("crmservice", "contact", req).then(function (res) { return __awaiter(_this, void 0, void 0, function () {
                                var _this = this;
                                var reqUser;
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0:
                                            if (!this.util.isSuccessResponse(res)) return [3 /*break*/, 4];
                                            if (!(res.contactid != null && res.contactid != "")) return [3 /*break*/, 2];
                                            contactid = res.contactid;
                                            this.cookieData.contactid = contactid;
                                            localStorage.setItem("dpa_portal", JSON.stringify(this.cookieData));
                                            reqUser = {
                                                firstname: this.cookieData.firstname,
                                                lastname: this.cookieData.lastname,
                                                username: this.cookieData.email
                                            };
                                            return [4 /*yield*/, this.apiService.postCustomApi("user", "InsertUser", reqUser).then(function (res) {
                                                    if (_this.util.isSuccessResponse(res) && res.code == "200") {
                                                        _this.router.navigate(["mainmenu/profile"]);
                                                    }
                                                })];
                                        case 1:
                                            _a.sent();
                                            return [3 /*break*/, 3];
                                        case 2:
                                            this.util.ErrorDialog("สร้าง Contact ไม่สำเร็จ");
                                            _a.label = 3;
                                        case 3: return [3 /*break*/, 5];
                                        case 4:
                                            this.util.ErrorDialog("สร้าง Contact ไม่สำเร็จ");
                                            _a.label = 5;
                                        case 5: return [2 /*return*/];
                                    }
                                });
                            }); })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    LoginComponent.prototype.goToRegister = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.router.navigate(["mainmenu/register"], { queryParams: { regisType: this.isCompany ? "c" : "n" } });
                return [2 /*return*/];
            });
        });
    };
    LoginComponent.prototype.goToForgetPass = function (type) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.router.navigate(["mainmenu/forgotPassword"], { queryParams: { type: type == 1 ? "password" : "username" } });
                return [2 /*return*/];
            });
        });
    };
    LoginComponent.prototype.goToForgetUser = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.router.navigate(["mainmenu/forgotUser"]);
                return [2 /*return*/];
            });
        });
    };
    LoginComponent.prototype.fbLibrary = function () {
        window.fbAsyncInit = function () {
            window['FB'].init({
                appId: '869805000070130',
                cookie: true,
                xfbml: true,
                version: 'v3.0'
            });
            window['FB'].AppEvents.logPageView();
        };
        (function (d, s, id) {
            var js, fjs = d.getElementsByTagName(s)[0];
            if (d.getElementById(id)) {
                return;
            }
            js = d.createElement(s);
            js.id = id;
            js.src = "https://connect.facebook.net/en_US/sdk.js";
            fjs.parentNode.insertBefore(js, fjs);
        }(document, 'script', 'facebook-jssdk'));
    };
    LoginComponent.prototype.goToIndex = function () {
        this.router.navigate(["mainmenu/index"]);
    };
    ////OTP
    LoginComponent.prototype.SubmitOTP = function () {
        return __awaiter(this, void 0, void 0, function () {
            var reqCheckOtp, reqCheckOtpRes, ticket;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(this.otp.trim().length > 0)) return [3 /*break*/, 7];
                        this.util.ShowWaiting(true);
                        reqCheckOtp = {
                            OTP: this.otp.trim(),
                            RefCode: this.otpRef,
                            MobileNo: this.telephoneOtp
                        };
                        return [4 /*yield*/, this.apiService.postCustomApi("crm", "VerifyOTP", reqCheckOtp)];
                    case 1:
                        reqCheckOtpRes = _a.sent();
                        if (!this.util.isSuccessResponse(reqCheckOtpRes)) return [3 /*break*/, 5];
                        if (!reqCheckOtpRes.IsValid) return [3 /*break*/, 3];
                        this.cookieData = this.dpa_portal;
                        localStorage.setItem("dpa_portal", JSON.stringify(this.dpa_portal));
                        return [4 /*yield*/, this.apiService.get("crmservice", "searchApprovalTicket", "contactid=" + this.cookieData.contactid)];
                    case 2:
                        ticket = _a.sent();
                        this.util.ShowWaiting(false);
                        /*
                        if (ticket != null && ticket.length > 0 && (ticket[0].dpa_approvalstatuscode == "01" || ticket[0].dpa_approvalstatuscode == "02" || ticket[0].dpa_approvalstatuscode == "06")) {
                          let url = this.util.baseUrl() + "/mainmenu/statusDocument/" + this.cookieData.contactid
                          window.open(url, "_blank")
                        }
                        */
                        this.router.navigate(["mainmenu"]);
                        return [3 /*break*/, 4];
                    case 3:
                        this.util.ShowWaiting(false);
                        this.util.WarningDialog("รหัส OTP ที่ท่านกรอกไม่ถูกต้อง");
                        _a.label = 4;
                    case 4: return [3 /*break*/, 6];
                    case 5:
                        this.util.ShowWaiting(false);
                        this.util.WarningDialog("พบข้อผิดพลาดในการยืนยันรหัส OTP กรูณาลองใหม่อีกครั้งหรือติดต่อเจ้าหน้าที่");
                        _a.label = 6;
                    case 6: return [3 /*break*/, 8];
                    case 7:
                        this.util.WarningDialog("กรุณาระบุรหัส OTP");
                        _a.label = 8;
                    case 8: return [2 /*return*/];
                }
            });
        });
    };
    LoginComponent.prototype.cancelOtp = function () {
        this.showLoginForm = true;
        this.showOtp = false;
        this.otp = "";
    };
    LoginComponent.prototype.requestOtp = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var reqOtp;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.util.ShowWaiting(true);
                        reqOtp = {
                            MobileNo: this.telephoneOtp,
                        };
                        return [4 /*yield*/, this.apiService.postCustomApi("crm", "RequestOTP", reqOtp).then(function (reqOtpRes) { return __awaiter(_this, void 0, void 0, function () {
                                var _this = this;
                                var smsContent, sendSms, sendSmsRes;
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0:
                                            if (!this.util.isSuccessResponse(reqOtpRes)) return [3 /*break*/, 2];
                                            smsContent = "รหัสตรวจสอบการล็อกอินของคุณคือ : ";
                                            smsContent += reqOtpRes.otpNo + " ";
                                            smsContent += "(RefCode : " + reqOtpRes.RefCode;
                                            smsContent += " ) (รหัสมีอายุ " + reqOtpRes.expInMinute + " นาที) อย่าเปิดเผยรหัสกับผู้อื่น";
                                            sendSms = {
                                                dpa_description: smsContent,
                                                dpa_phoneno: this.telephoneOtp
                                            };
                                            return [4 /*yield*/, this.apiService.post("crmservice", "sendSms", sendSms)];
                                        case 1:
                                            sendSmsRes = _a.sent();
                                            this.util.ShowWaiting(false);
                                            if (this.util.isSuccessResponse(sendSmsRes)) {
                                                this.otpRef = reqOtpRes.RefCode;
                                                this.otpTimer = 59;
                                                this.lastReqTime = new Date();
                                                this.requestOtpLblTmp = "ส่งอีกครั้ง";
                                                this.swithLbl();
                                                this.disableResentOtp = true;
                                                this.countdown();
                                                if (reqOtpRes.expInMinute == undefined || reqOtpRes.expInMinute == null) {
                                                    this.TotalTime = 300;
                                                }
                                                else {
                                                    this.TotalTime = reqOtpRes.expInMinute * 60;
                                                }
                                                this.ElapseTime = 0;
                                                if (this.SubScr != undefined) {
                                                    this.SubScr.unsubscribe();
                                                }
                                                this.SubScr = timer(0, 1000).subscribe(function () { return _this.CountDownOTP(); });
                                            }
                                            else {
                                                this.util.ErrorDialog("เกิดข้อผิดพลาดในการ ขอ Otp กรุณาลองใหม่อีกครั้ง หรือติดต่อเจ้าหน้าที่");
                                            }
                                            return [3 /*break*/, 3];
                                        case 2:
                                            this.util.ShowWaiting(false);
                                            this.util.ErrorDialog("เกิดข้อผิดพลาดในการ ขอ Otp กรุณาลองใหม่อีกครั้ง หรือติดต่อเจ้าหน้าที่");
                                            _a.label = 3;
                                        case 3: return [2 /*return*/];
                                    }
                                });
                            }); })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    LoginComponent.prototype.countdown = function () {
        var _this = this;
        if (this.otpTimer > 0) {
            var dif = new Date().getTime() - this.lastReqTime.getTime();
            var Seconds_from_T1_to_T2 = dif / 1000;
            this.otpTimer = this.totolWaitResend - Math.round(Seconds_from_T1_to_T2);
            setTimeout(function () {
                _this.countdown();
            }, 400);
        }
        else {
            this.disableResentOtp = false;
        }
    };
    LoginComponent.prototype.CountDownOTP = function () {
        if (this.ElapseTime == 0 && this.TotalTime == 0) {
            this.SubScr.unsubscribe();
            this.OTPCountDown = "";
            return;
        }
        if (this.ElapseTime == this.TotalTime) {
            this.SubScr.unsubscribe();
            this.ElapseTime = 0;
            this.OTPCountDown = "";
            return;
        }
        this.ElapseTime++;
        var RemainingSecs = this.TotalTime - this.ElapseTime;
        var RemainingMins = (RemainingSecs - (RemainingSecs % 60)) / 60;
        RemainingSecs = RemainingSecs % 60;
        this.OTPCountDown = " " + RemainingMins + ":" + (RemainingSecs < 10 ? "0" : "") + RemainingSecs;
    };
    LoginComponent.prototype.getContactDROS = function (idcard) {
        return __awaiter(this, void 0, void 0, function () {
            var para, tmp;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        para = "dpa_id=" + idcard + "&telephoneno=&fullname=&CRM05=false&CRM04=false&CRM03=false&CRM02=false&CRM07=false";
                        return [4 /*yield*/, this.apiService.get("crmservice", "contactDros", para)];
                    case 1:
                        tmp = _a.sent();
                        return [2 /*return*/, tmp];
                }
            });
        });
    };
    LoginComponent.prototype.getMenuObj = function (code) {
        if (this.menuList != null && this.menuList.length > 0) {
            var menuObj = this.menuList.filter(function (m) {
                return m.dpa_code == code;
            });
            if (menuObj != null && menuObj.length > 0) {
                if (menuObj[0].dpa_isdisplay == 3) {
                    menuObj[0].show = true;
                }
                else if (menuObj[0].dpa_isdisplay == 1 && !this.isCrisis) {
                    menuObj[0].show = true;
                }
                else if (menuObj[0].dpa_isdisplay == 2 && this.isCrisis) {
                    menuObj[0].show = true;
                }
                else {
                    menuObj[0].show = false;
                }
                return menuObj[0];
            }
            else {
                return {};
            }
        }
        else {
            return {};
        }
    };
    return LoginComponent;
}());
export { LoginComponent };



// WEBPACK FOOTER //
// ./src/app/account/login/login.component.ts.pre-build-optimizer.js